export const iconFontAwesomeGamingHeart = (
	<i className="fa-solid fa-heart"></i>
);
